
import { icons } from 'assets';
import AuthCodeInput from 'Components/main_components/registeration/AuthCodeInput';
import Button from 'Components/shared/button';
import { KeyInput } from 'Components/shared/inputs';
import Modal from 'Components/shared/modal';
import Text from 'Components/shared/text';
import useMounted from 'hooks/useMounted';
import React, { useEffect, useRef, useState } from 'react'
import styles from '../transfer_components.module.css';

const numbers = [1,2,3,4,5,6,7,8,9];
const numArr = [10,10,10,10];
const PinInput = ({onCancel, onConfirm, openModal, onClose}) => {
    const [pin, setPin] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const authCodeRef = useRef();
    const [keyPressed, setKeyPressed] = useState(-1);
    
    const pinInputHandler = (e,value) => {
       
        if(pin.length < 4) {
            const children =  authCodeRef.current.childNodes;
           
            setPin(prev => {
                
                if(prev.length < 4) {
                    const newState= [...prev, value];
                    children[prev.length].focus();
                    children[prev.length].click();
                    return newState;
                }
                else return prev;
            });
        }
    }
    const confirmHandler = () => {
        if(pin.length < 4){
            return false
        }
        setIsLoading(true)
        onConfirm?.(pin, () => {
            setPin([]);
            setIsLoading(false);
        });
    }
    const cancelHandler = (e) => {
        e.preventDefault();
        setPin(prev => {
            if(prev.length){
                const newState = [...prev];
                newState.pop();
                return newState;
            }
            else return prev;
        });
      
    }
    const inputHandler = (e, ind) => {
       setKeyPressed(e.target.value)
       setTimeout(() => {
        setKeyPressed(-1)
       },200)
        setPin(prev => {
            const newState = [...prev];
            newState[ind] = e.target.value;
            return newState.filter(num => !(num === '' || num === undefined));
        });
    }
    
    useEffect(() => {
        
        
        
        const keyDownHandler = (e) => {
           
            
            if(((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106 ) || e.keyCode == 8)) {
                if(e.keyCode > 47 && e.keyCode < 58) {
                   
                    setKeyPressed(e.keyCode - 48);
                    setTimeout(() => {
                        setKeyPressed(-1)
                       },200)
                    setPin(prev => {
                       
                        if(prev.length < 4) {
                            const newState = [...prev, e.keyCode - 48];
                            
                            return newState;
                        }
                        else return prev;
                    });
                }
                else if (e.keyCode > 95 && e.keyCode < 106) {
                    setKeyPressed(e.keyCode - 96)
                    setTimeout(() => {
                        setKeyPressed(-1)
                       },200)
                    setPin(prev => {
                       
                        if(prev.length < 4) {
                            const newState = [...prev, e.keyCode - 96];
                           
                            return newState;
                        }
                        else return prev;
                    });
                }
                else{
                    setPin(prev => {
                        if(prev.length){
                            const newState = [...prev];
                            newState.pop();
                            return newState;
                        }
                        else return prev;
                    });
                }
                return true;
            }
            else{
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            
        }
        window.addEventListener('keydown', keyDownHandler);
        return () => {
            
            window.removeEventListener('keydown', keyDownHandler);
        }
    },[]);
    
    const inputKeyHandler = (e) => {
        const children =  e.target.parentNode.childNodes;
        const index = Array.prototype.indexOf.call(children,e.target);
        if((e.target.value.length < 1 || e.keyCode == 8) && ((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106 ) || e.keyCode == 8)) {
            if(e.keyCode == 8){
                
                setPin(prev => {
                    if(prev.length && prev.length < 4){
                        children[index -1]?.click();
                        children[index - 1]?.focus();
                        const newState = [...prev];
                        newState.pop();
                        return newState;
                    }
                    else return prev;
                });
            }
            e.stopPropagation();
            return true;
        }
        else if(e.keyCode == 13 || e.target.value.length >=1){
           
           
            if(index === 4 -1){
                e.stopPropagation();
                e.preventDefault();
            }
            else if(children[index + 1].value.length < 1){

                children[index + 1].click();
                children[index + 1].focus();
                e.stopPropagation();
            }
            else{
                    children[index + 1].click();
                    children[index + 1].focus();
                    e.stopPropagation();
                    e.preventDefault();
                    return false;  
            }
        }
       
        else{
           e.stopPropagation();
            e.preventDefault();
            return false;
        }
        
    }
   
    return (
        <Modal open={openModal} onClose={onClose} disableBackdropClick padding={false} unmountOnExit={true}  >
            <div className='w-full modal-padding' >
            <Text variant="md2" style={{fontWeight:700, paddingBottom:"38px"}}>
                Enter Your Pin
            </Text>
            <div className={`row-start w-full `} style={{gap:"1rem",justifyContent:"space-between"}} ref={authCodeRef}>
                {
                    numArr.map((_,ind) => {
                        if(ind === 0) return  <KeyInput key={ind} onKeyDown={inputKeyHandler} autoFocus value={pin[ind] < 10 ? pin[ind] : ""} onChange={(e) => inputHandler(e,ind)}  name={`keyInput-${ind}`}/>
                        else return <KeyInput key={ind} value={pin[ind] < 10 ? pin[ind] : ""}onKeyDown={inputKeyHandler} onChange={(e) => inputHandler(e,ind)}  name={`keyInput-${ind}`} />
                    })
                }
                
            </div>
            <div className='row-start' style={{marginTop:"24px", gap:"1rem"}}>
                <Button onClick={onCancel} style={{backgroundColor:"var(--social-background)", minWidth:"0", flexGrow:1}}>Cancel</Button>
                <Button onClick={confirmHandler} style={{flexGrow:3}} loading={isLoading}>Confirm</Button>
            </div>
            </div>
            <div className='w-full modal-padding' style={{backgroundColor:"#F1F5F9",paddingBottom:"44px" }} >
                <div className="row-start w-full" style={{flexWrap:"wrap",gap:"6px", justifyContent:"flex-end"}} >
                    {
                        numbers.map((number, index) => (
                            <NumPad key={number} value={number} onClick={(e) => pinInputHandler(e,number)} keyPressed={keyPressed == number} />
                        ))    
                    }
                    <NumPad value={0} onClick={(e) => pinInputHandler(e,0)} keyPressed={keyPressed == 0} />
                    <Button variant="empty" style={{maxWidth:"31.80%",height:"46px", outline:"none"}} onClick={cancelHandler}>
                        <img src={icons.cancelButton} alt="cancel" style={{width:"32px", height:"32px"}} />
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

const NumPad = ({onClick, value, keyPressed}) => {
  
    
  
    const clickHandler = (e) => {
        e.preventDefault();
        onClick?.(e,value);
    }
    // useEffect(() => {
    //     let timer;
    //     if(keyPressed){
    //         setActive(true)
    //         timer =  setTimeout(() => {
    //             setActive(false)
    //         }, 200);
    //     }
        
    //     return () => {
    //         if(timer)
    //         clearTimeout(timer)
    //     }
    // },[keyPressed])
    return (
        <Button onClick={clickHandler} className={`${styles.Numpad} ${keyPressed ? styles.active : ""}`}
        >{value}</Button>
    )
}


export default PinInput;